import React from "react";

import InventoryOverviewLowStockTable from "components/molecules/tabels/inventory/InventoryOverviewLowStockTable";
import InventoryOverviewExpiringTable from "components/molecules/tabels/inventory/InventoryOverviewExpiringTable";

function ProductsSideModal({ modalView, data }) {
  let view;
  switch (modalView) {
    case 0:
      view = <InventoryOverviewExpiringTable data={data} />;
      break;
    case 1:
      view = <InventoryOverviewLowStockTable data={data} />;
      break;

    default:
      break;
  }
  return <>{view}</>;
}

export default ProductsSideModal;
